// const { setTimeout } = require("core-js");

function sleepjs(milliseconds) {
	const date = Date.now();
	let currentDate = null;
	do {
	  currentDate = Date.now();
	} while (currentDate - date < milliseconds);
  }
//Initialize Accordion
if (document.querySelector(".accordion-container")) {
	new Accordion(".accordion-container");
}

//Carousel Script
if (document.querySelector(".glide__slides")) {
	var allSlides = document.querySelectorAll(".glide");
	var allSlidesArray = Array.prototype.slice.call(allSlides);
	allSlidesArray.forEach((slide) => {
		const glide = new Glide(slide, {
			type: "slider",
			perView: 3,
			perTouch: 1,
			focusAt: "center",
			autoplay: false,
			accessibility: true,
			startAt: 2,
			rewind: false,
			classes: {
				disabledArrow: "glide__arrow--disabled",
			},
			peek: {
				before: 100,
				after: 50,
			},
			perSwipe: "|",
			breakpoints: {
				800: {
					perView: 1,
					startAt: 1,
					peek: 0,
				},
			},
		}).mount();
	});
}

//Check if Header Button link is external
const btns = document.querySelectorAll(".wp-block-button__link");
const allBtns = Array.prototype.slice.call(btns);
const currentHost = window.location.hostname;

let externalText = document.createElement("span");
externalText.append(document.createTextNode("link will open external site"));
externalText.classList.add("screen-reader-text");

if (btns) {
	allBtns.forEach((btn) => {
		if (btn.hasAttribute("href")) {
			let ctaLink = btn.getAttribute("href").split("/");

			if (ctaLink[2] !== currentHost) {
				btn.classList.add("external-link");
				btn.append(externalText);
			}
		}
	});
}
if (document.querySelector(".cta-btn")) {
	let currentHost = window.location.hostname;
	let ctaBtn = document.querySelector(".cta-btn");
	let ctaLink = ctaBtn.getAttribute("href").split("/");

	if (ctaLink[0] !== currentHost) {
		ctaBtn.classList.add("external-link");
		ctaBtn.append(externalText);
	}
}


////Pagination
if (document.querySelector(".navigation-pagination")) {
	let paginationList = document.querySelectorAll(".navigation-pagination ul li");

	if (paginationList[0].classList.contains("active")) {
		paginationList[0].style.position = "relative";
	}

	if (paginationList[paginationList.length - 1].classList.contains("active")) {
		paginationList[paginationList.length - 1].style.position = "relative";
	}
}

////Masonary
if (document.querySelector(".allcontainer")) {
	var elem = document.querySelector(".allcontainer");
	var msnry = new Masonry(elem, {
		// options
		itemSelector: ".item",
		columnWidth: ".grid-sizer",
		gutter: 15,
	});

	//Filters
	// const filterBtn = document.querySelectorAll('.filters button');
	// var allfilterBtn = Array.prototype.slice.call(filterBtn);
	//let allblocks = document.querySelectorAll('.item');
	let allblocks = Array.prototype.slice.call(document.querySelectorAll(".item"));
	let selectedValue;
	let selectedOption;
	let availableItems;
	let buttons = document.querySelectorAll(".filters button"); //returns a nodelist

	for (let i = 0; i < buttons.length; i++) {
		buttons[i].addEventListener("click", onClickChange);
	}

	//Click Filter
	function onClickChange() {
		selectedValue = this.value;
		// if(selectedValue !== 'all'){
		//   allblocks = document.querySelectorAll('.item.block');
		// }
		allblocks.forEach(function (block) {
			block.classList.remove("block");

			if (selectedValue == "all") {
				block.classList.add("block");
			}

			if (block.getAttribute("data-cat") == selectedValue) {
				block.classList.add("block");
			}
		});
		msnry.layout();

		availableItems = Array.prototype.slice.call(document.querySelectorAll(".item.block"));
		document.getElementById("select").addEventListener("change", onSelectChange);
	}

	availableItems = Array.prototype.slice.call(document.querySelectorAll(".item.block"));

	document.getElementById("select").addEventListener("change", onSelectChange);

	function onSelectChange() {
		selectedOption = this.value;

		availableItems.forEach(function (item) {
			item.classList.remove("block");

			if (selectedOption == "all") {
				item.classList.add("block");
			}

			if (item.getAttribute("data-tag") == selectedOption) {
				item.classList.add("block");
			}
		});

		//Filter Click
		for (let i = 0; i < buttons.length; i++) {
			buttons[i].addEventListener("click", onClickChange);
		}

		msnry.layout();
	}

	/////Script_AJAX
	/* Ajax functions */
	$(document).ready(function () {
		//onclick
		$("#loadMore").on("click", function (e) {
			e.preventDefault();
			//init
			var that = $(this);
			var page = $(this).data("page");
			var newPage = page + 1;
			var ajaxurl = that.data("url");
			//ajax call
			$.ajax({
				url: ajaxurl,
				type: "post",
				data: {
					page: page,
					action: "ajax_script_load_more",
				},
				error: function (response) {
					console.log(response);
				},
				success: function (response) {
					//check
					if (response == 0) {
						$(".allcontainer").append('<div class="text-center no-more-post"><h4>You reached the end of the line!</h4><p>No more posts to load.</p></div>');
						$("#loadMore").hide();
					} else {
						that.data("page", newPage);
						$("#ajax-primary").append(response);

						msnry = new Masonry(elem, {
							// options
							itemSelector: ".item",
							columnWidth: ".grid-sizer",
							gutter: 15,
						});

						msnry.layout();
					}
				},
			});
		});
	});
}

//Breadcrumb Spacing
if (document.querySelector(".breadcrumb-container")) {
	document.querySelector(".content-area").style.marginTop = 0;
}

//Button Custom Colors Hover
var customBtn = $(".wp-block-button a.has-text-color.has-background");

customBtn.each(function (index) {
	var btnbgColor = $(this).css("backgroundColor");
	var btnColor = $(this).css("color");

	$(this)
		.mouseenter(function () {
			$(this).css({
				"background-color": btnColor,
				color: btnbgColor,
				"border-color": btnColor
			});
		})
		.mouseleave(function () {
			$(this).css({
				"background-color": btnbgColor,
				color: btnColor,
				"border-color": btnbgColor
			});
		});
});

// For header footer scrolling
window.addEventListener('DOMContentLoaded', (event) => {

    var lastScrollTop = 0;
	var timer = null;
	var lastscrollheight = window.scrollY;
	var isScrolling;
// element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.

window.addEventListener("scroll", function(){ // or window.addEventListener("scroll"....
	// Clear our timeout throughout the scroll
	window.clearTimeout( isScrolling );

	// Set a timeout to run after scrolling ends
	isScrolling = setTimeout(function() {
		// Run the callback
		//console.log( 'Scrolling has stopped.' );
		// do something if scrolled atleast 40 px
					if(lastscrollheight > window.scrollY + 100 || lastscrollheight < window.scrollY - 100){
						lastscrollheight = window.scrollY;
					var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
						if (st > lastScrollTop){
							$('header.site-header').slideUp('slow');
							//$('footer .searchbox').slideDown('slow');
								// downscroll code
								// sleepjs(1000);

						} else {
							// upscroll code
							$('header.site-header').slideDown('slow');
							//$('footer .searchbox').slideUp('slow');
							//sleepjs(1000);
						}
			lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
			}
	}, 66);
}, false);
});

// mouse trap for top level menu

window.addEventListener('DOMContentLoaded', (event) => {mobiletopmenuaccessibility()});
function mobiletopmenuaccessibility(){
var sidemenu = document.querySelector(".only-mobile-menu");
if(sidemenu){
//const  focusableElementssubmenu = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
const  focusableElementssubmenu = 'ul:not(.nav__sub)>li>a';
const firstFocusableElementsubmenu = sidemenu.querySelectorAll(focusableElementssubmenu)[0]; // get first element to be focused inside modal
const focusableContentsubmenu = sidemenu.querySelectorAll(focusableElementssubmenu);

const lastFocusableElementsubmenu = focusableContentsubmenu[focusableContentsubmenu.length - 1]; // get last element to be focused inside modal


document.addEventListener('keydown', function(e) {
	
  let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
  let isEnterPressed =  e.keyCode === 13;
//   if(isEnterPressed){
//     if (document.activeElement === firstFocusableElementsubmenu) {
//       sidemenu.style.display = "none";
//       e.preventDefault();
//     }
//   }

  if (!isTabPressed) {
    return;
  }

  if (e.shiftKey) { // if shift key pressed for shift + tab combination
    if (document.activeElement === firstFocusableElementsubmenu) {
      lastFocusableElementsubmenu.focus(); // add focus for the last focusable element
      e.preventDefault();
	  
    }
  } else { // if tab key is pressed
    if (document.activeElement === lastFocusableElementsubmenu) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
      document.querySelector(".hamicon").focus(); // add focus for the first focusable element
     // firstFocusableElementsubmenu.focus(); // add focus for the first focusable element
      e.preventDefault();
	  
    }
  }
});
}
// second level menu focus trap 
secondlevelmenyaccessibility();

}
function secondlevelmenyaccessibility(){
	var sidemenu = document.querySelectorAll(".only-mobile-menu ul.nav__sub.sub:not(.subsub)");
if(sidemenu){

	// startforeach for all submenus
	for(let i = 0; i < sidemenu.length; i++){
//const  focusableElementssubmenu = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
const  focusableElementssubmenu = 'li.subc>a';
const firstFocusableElementsubmenu = sidemenu[i].querySelectorAll(focusableElementssubmenu)[0]; // get first element to be focused inside modal
const focusableContentsubmenu = sidemenu[i].querySelectorAll(focusableElementssubmenu);

const lastFocusableElementsubmenu = focusableContentsubmenu[focusableContentsubmenu.length - 1]; // get last element to be focused inside modal


sidemenu[i].addEventListener('keydown', function(e) {
	
  let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
  let isEnterPressed =  e.keyCode === 13;


  if (!isTabPressed) {
    return;
  }

  if (e.shiftKey) { // if shift key pressed for shift + tab combination
    if (document.activeElement === firstFocusableElementsubmenu) {
      lastFocusableElementsubmenu.focus(); // add focus for the last focusable element
      e.preventDefault();
	  
    }
  } else { // if tab key is pressed
    if (document.activeElement === lastFocusableElementsubmenu) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
      //document.querySelector(".hamicon").focus(); // add focus for the first focusable element
      firstFocusableElementsubmenu.parentNode.parentNode.querySelector(".sub__close").focus(); // add focus for the first focusable element
      //firstFocusableElementsubmenu.focus(); // add focus for the first focusable element
      e.preventDefault();
	  
    }
  }
});
	}
// end foreach for all sub menus
}
thirdlevelmenyaccessibility();
}
function thirdlevelmenyaccessibility(){
	var sidemenu = document.querySelectorAll(".only-mobile-menu ul.nav__sub.subsub");
	//console.log(sidemenu.length + " subsub menus")
if(sidemenu){
	for(let i = 0; i < sidemenu.length; i++){
//const  focusableElementssubmenu = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
const  focusableElementssubmenu = 'li.subsubc>a';
const firstFocusableElementsubmenu = sidemenu[i].querySelectorAll(focusableElementssubmenu)[0]; // get first element to be focused inside modal
const focusableContentsubmenu = sidemenu[i].querySelectorAll(focusableElementssubmenu);

const lastFocusableElementsubmenu = focusableContentsubmenu[focusableContentsubmenu.length - 1]; // get last element to be focused inside modal


sidemenu[i].addEventListener('keydown', function(e) {
	
  let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
  let isEnterPressed =  e.keyCode === 13;

  if (!isTabPressed) {
    return;
  }

  if (e.shiftKey) { // if shift key pressed for shift + tab combination
    if (document.activeElement === firstFocusableElementsubmenu) {
		//console.log("inside sub sub menu first");
		
      lastFocusableElementsubmenu.focus(); // add focus for the last focusable element
      e.preventDefault();
	  
    }
  } else { // if tab key is pressed
	
    if (document.activeElement === lastFocusableElementsubmenu) {
		//console.log("inside sub sub menu last");
		
		// if focused has reached to last focusable element then focus first focusable element after pressing tab
      //document.querySelector(".hamicon").focus(); // add focus for the first focusable element
      firstFocusableElementsubmenu.parentNode.parentNode.querySelector(".sub__close").focus(); // add focus for the first focusable element
      e.preventDefault();
	  
    }
  }
});
}
}
}


//listing image
window.addEventListener('DOMContentLoaded', (event) => {listingpeoplehovereffect()});
function listingpeoplehovereffect(){
	let peopleList = document.querySelectorAll(".people .people-background-image");
	if(peopleList){

	for(let i = 0; i<peopleList.length; i++){
		//for mouseover
		peopleList[i].addEventListener('mouseover', function(e){
			let hoverImg = e.target.getAttribute('hover-image');
			if(hoverImg){
				e.target.style.backgroundImage = 'url('+hoverImg+')';
			}
		})

		//for mouseleaves
		peopleList[i].addEventListener('mouseleave', function(e){
			let defaultImg = e.target.getAttribute('default-image');
			if(defaultImg){
				e.target.style.backgroundImage = 'url('+defaultImg+')';
			}
		})
	}
	}
}
//header-lang-list li add attribute tabindex=0




//submenu focus
window.addEventListener('DOMContentLoaded', (event) => {
	function removefocusclass(){
		var mainmenufocus= document.querySelectorAll(".only-desktop-menu a");
	if(mainmenufocus){
		for(var x=0; x<mainmenufocus.length; x++){
		let focusedOrHasFocusedmenuitem = mainmenufocus[x].parentNode.matches(':focus-within');
				
                if(!focusedOrHasFocusedmenuitem){
					var focusedelement= mainmenufocus[x];
					focusedelement.parentNode.classList.remove("focus");
					focusedelement.parentNode.classList.remove("opensubmenu");
					focusedelement.setAttribute("aria-expanded", false);
					
				}
	}
	}
	}
	// alert ("page loaded shachi");
	var mainmenufocus= document.querySelectorAll(".only-desktop-menu a");
	if(mainmenufocus){
		for(var x=0; x<mainmenufocus.length; x++){
			
			mainmenufocus[x].addEventListener("focus", function(e){

				var focusedelement= e.target;
				focusedelement.parentNode.classList.add("focus");
				if(e.target.parentNode.classList.contains("has-children")){
					e.target.setAttribute("aria-expanded", true);
				}
				

			}
			)
			mainmenufocus[x].addEventListener("focusout", function(e){
				
				//console.log(e.target.parentNode.contains(document.activeElement));
				let focusedOrHasFocused = e.target.parentNode.matches(':focus-within');
				// console.log(focusedOrHasFocused);
                if(!focusedOrHasFocused){
					var focusedelement= e.target;
					focusedelement.parentNode.classList.remove("focus");
					focusedelement.parentNode.classList.remove("opensubmenu");

					if(e.target.parentNode.classList.contains("has-children")){
						e.target.setAttribute("aria-expanded", false);
					}
				}
				
				removefocusclass();
			}
			)
		
			mainmenufocus[x].addEventListener("keydown", function(e){
				
                //  console.log(e.which);
				//  console.log(e.keyCode);
				 var keypressed= e.which || e.keyCode;
				 var enterpressed= e.which || e.keyCode;
				 
					if(keypressed==9){
						if(e.target.parentNode.classList.contains("has-children")){
                            // e.target.nextSibling.focus();
							var focusedelement= e.target;
							
				
							//   e.preventDefault();
							//   focusedelement.parentNode.classList.add("focus");
							// console.log(e.target.parentNode);
							var focusremove= e.target.parentNode.querySelector(".submenu a");
							//focusremove.focus();
							//  console.log(focusremove);
							// e.returnValue = true;
						}
					}
					// if(enterpressed==13){
					// 	if(e.target.parentNode.classList.contains("has-children")){
					// 		e.preventDefault();
					// 		var focuswithenter= e.target;
					// 		focuswithenter.parentNode.classList.add("opensubmenu");
							
							
					// 	}
					// }
				
				

			}
			)
			mainmenufocus[x].addEventListener("click", function(e){

                

				if(e.target.parentNode.classList.contains("has-children")){

					e.preventDefault();

					var focuswithenter= e.target;

					// focuswithenter.parentNode.classList.add("opensubmenu");
					if(focuswithenter.parentNode.classList.contains("opensubmenu")){
						
						focuswithenter.parentNode.classList.remove("opensubmenu");
					}
					else{
                    
						
						focuswithenter.parentNode.classList.add("opensubmenu");
					}

					

					

				}

			}
    
	  )
	
	                 

		}


	}

}
)
// let mobilemenu = document.querySelector(".only-mobile-menu .main-navigation .nav-container .row");
// let mobilemenuparent = document.querySelector(".only-mobile-menu");
// if (mobilemenu.children.length === 0) {
//   mobilemenuparent.style.display = "none";
// }


// copy link
let copybuttons = document.querySelectorAll('.social-share-single-post-sidebar li:last-child a');
if(copybuttons){
    for(let i =0; i <copybuttons.length;i++){
        copybuttons[i].addEventListener("click",function(e){
            e.preventDefault();
            let ctarget = e.currentTarget;
            navigator.clipboard.writeText(e.currentTarget.href);
            e.currentTarget.querySelector("span").innerText = "Copied!";
            setTimeout(function(){
                ctarget.querySelector("span").innerText = "Copy Link";
            }, 2000);
        });
        
    }
}

let copybuttonsbottom = document.querySelectorAll('.social-share-single-post li:last-child a');
if(copybuttonsbottom){
	for(let i =0; i <copybuttonsbottom.length;i++){
		copybuttonsbottom[i].addEventListener("click",function(e){
			e.preventDefault();
			let ctarget = e.currentTarget;
			let innerhtmlforthis = e.currentTarget.firstChild;
			
			navigator.clipboard.writeText(e.currentTarget.href);
			e.currentTarget.innerText = "Copied";
			setTimeout(function(){
				//console.log(innerhtmlforthis);
				//console.log(ctarget);
				ctarget.innerText = "";
				ctarget.appendChild(innerhtmlforthis);
			}, 2000);
		});
		
	}
}

var submenuclick= document.querySelectorAll(".main-navigation.mega-menu .submenu-level-1 li.has-children a");
if(submenuclick){
	for(var x=0; x<submenuclick.length; x++){
		submenuclick[x].addEventListener("click", function(e){
			let event=e;
			// closeallleveltwomenus();
			// setTimeout(function(){
			// 	event.target.parentElement.querySelector(".submenu-level-2").style.display= "inline-block";
			// 	},100);
			// e.target.parentElement.querySelector(".submenu-level-2").style.display= "inline-block";
			var closemenuclick= event.target.parentElement.querySelector(".submenu-level-2");
			if(window.getComputedStyle(closemenuclick).display === "none"){
				
				closeallleveltwomenus();
				event.target.parentElement.querySelector(".submenu-level-2").style.display="inline-block";
				
			}
			else{
				
				closeallleveltwomenus();
				event.target.parentElement.querySelector(".submenu-level-2").style.display="none";
				
			}
			
			
		})
	}
}   
function closeallleveltwomenus(){
	var thirdlevelmenu= document.querySelectorAll(".main-navigation.mega-menu .submenu-level-1 li.has-children .submenu-level-2");
	if(thirdlevelmenu){
       for(var x=0; x<thirdlevelmenu.length; x++){
		thirdlevelmenu[x].style.display= "none";
		
	   }
	}
}
// window.addEventListener("scroll", function(){
// 	if(window.scrollY<=0){
// 	  document.querySelector(".site-header").style.boxShadow = "";
// 	} else {
// 	  document.querySelector(".site-header").style.boxShadow = "0px 5px 15px rgba(0, 0, 3, 0.15)";
// 	}
//   });
  window.addEventListener('DOMContentLoaded', (event) => {
    // document.querySelector(".site-header").style.boxShadow = "";
    // document.querySelector(".site-header").style.webkitBoxShadow = "";
    // document.querySelector(".site-header").style.mozBoxShadow = "";



window.addEventListener("scroll", function(){



   if(window.scrollY<=0){



     document.querySelector(".site-header").style.boxShadow = "";
      document.querySelector(".site-header").style.webkitBoxShadow = "";
      document.querySelector(".site-header").style.mozBoxShadow = "";
    } else {



     document.querySelector(".site-header").style.boxShadow = "0px 5px 15px rgba(0, 0, 3, 0.15)";
      document.querySelector(".site-header").style.webkitBoxShadow = "0px 5px 15px rgba(0, 0, 3, 0.15)";
      document.querySelector(".site-header").style.mozBoxShadow = "0px 5px 15px rgba(0, 0, 3, 0.15)";
    }



 });
 addactiveclasstomenu(".megamenu li");
});
function addactiveclasstomenu(menuselector){
    // menuselector = ".megamenu li";
    let currenturl = window.location.origin+window.location.pathname;
let allmenuitems = document.querySelectorAll(menuselector);
if(allmenuitems){
    for(let i = 0 ; i < allmenuitems.length; i++){
    let currentli = allmenuitems[i];
    currentli.classList.remove("active");
    }

    for(let i = 0 ; i < allmenuitems.length; i++){
        let currentli = allmenuitems[i];
        let allainside = allmenuitems[i].querySelectorAll("a");
        if(allainside){
            for(let j = 0; j < allainside.length; j++){
            let currentahref = allainside[j].href;
                if(currentahref == currenturl){
                    currentli.classList.add("active");
                }
            }
        }  
    }
}
}